import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const caseStudies = [
    {
        id: 'inventory-automation',
        title: 'E-commerce Inventory Sync',
        category: 'Automation',
        description: 'Automated inventory tracking across 3 platforms, saving 15 hours/week.',
        result: '15 hrs/week saved',
    },
    {
        id: 'reporting-dashboard',
        title: 'Sales Reporting Dashboard',
        category: 'Dashboard',
        description: 'Real-time sales dashboard replacing manual monthly reports.',
        result: '2 days → 5 minutes',
    },
    {
        id: 'lead-scoring',
        title: 'AI Lead Scoring System',
        category: 'AI Integration',
        description: 'Automated lead qualification using AI, improving conversion rates.',
        result: '40% more conversions',
    },
];

export const CaseStudies = () => {
    return (
        <section id="case-studies" className="py-20 md:py-28 bg-white" data-testid="case-studies-section">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                {/* Section Header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-16"
                >
                    <p className="text-[#34A853] text-sm font-medium uppercase tracking-widest mb-4">
                        Case Studies
                    </p>
                    <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4">
                        Real Projects, Real Results
                    </h2>
                    <p className="text-[#6B6B6B] text-lg max-w-2xl mx-auto">
                        See how businesses like yours are saving time with automation.
                    </p>
                </motion.div>

                {/* Case Studies Grid */}
                <div className="grid md:grid-cols-3 gap-8">
                    {caseStudies.map((study, index) => (
                        <motion.a
                            key={study.id}
                            href={`/case-study/${study.id}`}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            className="group bg-[#FAFAFA] rounded-2xl p-6 border border-[#E5E5E5] hover:border-[#34A853]/50 hover:shadow-card transition-all duration-300"
                            data-testid={`case-study-card-${index}`}
                        >
                            {/* Category Badge */}
                            <span className="inline-block bg-[#E8F5E9] text-[#34A853] text-xs font-medium px-3 py-1 rounded-full mb-4">
                                {study.category}
                            </span>
                            
                            <h3 className="font-serif text-xl font-semibold text-[#2C2C2C] mb-2 group-hover:text-[#34A853] transition-colors">
                                {study.title}
                            </h3>
                            
                            <p className="text-[#6B6B6B] text-sm leading-relaxed mb-4">
                                {study.description}
                            </p>

                            {/* Result */}
                            <div className="flex items-center justify-between pt-4 border-t border-[#E5E5E5]">
                                <span className="text-[#34A853] font-semibold">{study.result}</span>
                                <ArrowRight size={18} className="text-[#6B6B6B] group-hover:text-[#34A853] group-hover:translate-x-1 transition-all" />
                            </div>
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
};
